import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { ICorrector } from './contracts';

angular.module('ui-ng-calendar').factory('removeTimeOccurrenceCorrectorFactory', function () {
  return (originalTimeOccurrence: ITimeOccurrenceDatatype): ICorrector =>
    function removeTimeOccurrenceCorrector(store: ITimeOccurrenceDatatype[]) {
      _.remove(store, originalTimeOccurrence);
      return store;
    };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/validation/remove_time_occurrence_corrector.ts